// src/i18n/index.js
//
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import ptCommon from "./pt-BR/common.json";
import ptAuth from "./pt-BR/auth.json";
import ptMural from "./pt-BR/mural.json";
import ptEntrepreneurs from "./pt-BR/entrepreneurs.json";
import ptAccount from "./pt-BR/account.json";

import enCommon from "./en/common.json";
import enAuth from "./en/auth.json";
import enMural from "./en/mural.json";
import enEntrepreneurs from "./en/entrepreneurs.json";
import enAccount from "./en/account.json";

import esCommon from "./es/common.json";
import esAuth from "./es/auth.json";
import esMural from "./es/mural.json";
import esEntrepreneurs from "./es/entrepreneurs.json";
import esAccount from "./es/account.json";

// Códigos curtos para alinhar com os códigos do Google Translate (pt, en, es).
export const SUPPORTED_LANGUAGES = ["pt", "en", "es"];
export const DEFAULT_LANGUAGE = "pt";

const resources = {
  pt: {
    common: ptCommon,
    auth: ptAuth,
    mural: ptMural,
    entrepreneurs: ptEntrepreneurs,
    account: ptAccount,
  },
  en: {
    common: enCommon,
    auth: enAuth,
    mural: enMural,
    entrepreneurs: enEntrepreneurs,
    account: enAccount,
  },
  es: {
    common: esCommon,
    auth: esAuth,
    mural: esMural,
    entrepreneurs: esEntrepreneurs,
    account: esAccount,
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    lng: DEFAULT_LANGUAGE,
    fallbackLng: DEFAULT_LANGUAGE,
    supportedLngs: SUPPORTED_LANGUAGES,
    // Quando o usuário tiver `pt-BR` salvo de uma versão anterior, mapeamos
    // para `pt` automaticamente (load: 'languageOnly' descarta o sufixo de
    // região no lookup).
    load: "languageOnly",
    ns: ["common", "auth", "mural", "entrepreneurs", "account"],
    defaultNS: "common",
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ["localStorage"],
      lookupLocalStorage: "uiLang",
      caches: ["localStorage"],
    },
    react: {
      // Sem Suspense: garante que os componentes renderizem com as traduções
      // já disponíveis (estamos com resources bundled, init é síncrono).
      useSuspense: false,
    },
    returnEmptyString: false,
  });

export default i18n;
